const RolePermissions =
    {
        "admin_user": {
            "access-denied": {hasAccess: true},
            "admin": {hasAccess: true},
            "billing": {hasAccess: true},
            "company": {hasAccess: true},
            "faq": {hasAccess: true},
            "manage-users":  {hasAccess: true},
            "settings": {hasAccess: true},
            'board-stats': {hasAccess: true},
            'business-digest': {hasAccess: true},
            'config': {hasAccess: true},
            'account-management': {hasAccess: true},
            'customer-invoices': {hasAccess: true},
            'department-spend': {hasAccess: true},
            'arr-schedule': {hasAccess: true},
            'dealexplorer': {hasAccess: true},
            'forecast': {hasAccess: true},
            'forecast-setup': {hasAccess: true},
            'gtm-stats': {hasAccess: true},
            'gtm-stats-segments': {hasAccess: true},
            'inbound-follow-up': {hasAccess: true},
            'opp-creation': {hasAccess: true},
            'pclose': {hasAccess: true},
            'pconvert': {hasAccess: true},
            'pipeline-forensics': {hasAccess: true},
            'pipelineflows': {hasAccess: true},
            'attribution-setup': {hasAccess: true},
            'program-effectiveness': {hasAccess: true},
            'programeffectiveness': {hasAccess: true},
            'gtm-activity': {hasAccess: true},
            'meetings': {hasAccess: true},
            'rep-ramp': {hasAccess: true},
            'scenarios': {hasAccess: true},
            'win-rate': {hasAccess: true},
            'winflows': {hasAccess: true},
            'entity-match': {hasAccess: true},
            'win-loss-reasons': {hasAccess: true},
            'renewal-matching': {hasAccess: true},
            'hygiene': {hasAccess: true},
            'recipe-designer': {hasAccess: true},
            'recipe-results': {hasAccess: true},
            'goal-sets': {hasAccess: true},
            'quota-setup': {hasAccess: true},
            'metadata-setup': {hasAccess: true},
            'manage-prompts': {hasAccess: true},
            'integrations': {hasAccess: true},
            'desktop-tools': {hasAccess: true},
            'scenario-settings': {hasAccess: true},
            'inbound-response-setup': {hasAccess: true},
            'configure-data': {hasAccess: true},
            'security': {hasAccess: true},
            'terms': {hasAccess: true},
        },

        "general_user": {
            "access-denied": {hasAccess: true},
            "admin": {hasAccess: false},
            "billing": {hasAccess: false},
            "company": {hasAccess: false},
            "faq": {hasAccess: true},
            "manage-users":  {hasAccess: false},
            "settings": {hasAccess: true},
            'board-stats': {hasAccess: true},
            'business-digest': {hasAccess: true},
            'config': {hasAccess: true},
            'account-management': {hasAccess: true},
            'customer-invoices': {hasAccess: true},
            'department-spend': {hasAccess: false},
            'arr-schedule': {hasAccess: false},
            'dealexplorer': {hasAccess: true},
            'forecast': {hasAccess: true},
            'forecast-setup': {hasAccess: false},
            'gtm-stats': {hasAccess: true},
            'gtm-stats-segments': {hasAccess: false},
            'inbound-follow-up': {hasAccess: true},
            'opp-creation': {hasAccess: true},
            'pclose': {hasAccess: true},
            'pconvert': {hasAccess: true},
            'pipeline-forensics': {hasAccess: true},
            'pipelineflows': {hasAccess: true},
            'attribution-setup': {hasAccess: false},
            'program-effectiveness': {hasAccess: true},
            'programeffectiveness': {hasAccess: true},
            'gtm-activity': {hasAccess: true},
            'meetings': {hasAccess: true},
            'rep-ramp': {hasAccess: true},
            'scenarios': {hasAccess: true},
            'win-rate': {hasAccess: true},
            'winflows': {hasAccess: true},
            'entity-match': {hasAccess: true},
            'win-loss-reasons': {hasAccess: true},
            'renewal-matching': {hasAccess: true},
            'hygiene': {hasAccess: true},
            'recipe-designer': {hasAccess: true},
            'recipe-results': {hasAccess: true},
            'goal-sets': {hasAccess: true},
            'quota-setup': {hasAccess: false},
            'metadata-setup': {hasAccess: false},
            'manage-prompts': {hasAccess: false},
            'integrations': {hasAccess: false},
            'desktop-tools': {hasAccess: true},
            'scenario-settings': {hasAccess: false},
            'inbound-response-setup': {hasAccess: false},
            'configure-data': {hasAccess: false},
            'security': {hasAccess: true},
            'terms': {hasAccess: true},
        },
        "sales_user": {
            "access-denied": {hasAccess: true},
            "admin": {hasAccess: false},
            "billing": {hasAccess: false},
            "company": {hasAccess: false},
            "faq": {hasAccess: true},
            "manage-users":  {hasAccess: false},
            "settings": {hasAccess: true},
            'board-stats': {hasAccess: false},
            'business-digest': {hasAccess: false},
            'config': {hasAccess: false},
            'account-management': {hasAccess: false},
            'customer-invoices': {hasAccess: false},
            'department-spend': {hasAccess: false},
            'arr-schedule': {hasAccess: false},
            'dealexplorer': {hasAccess: false},
            'forecast': {hasAccess: true},
            'forecast-setup': {hasAccess: false},
            'gtm-stats': {hasAccess: false},
            'gtm-stats-segments': {hasAccess: false},
            'inbound-follow-up': {hasAccess: false},
            'opp-creation': {hasAccess: false},
            'pclose': {hasAccess: false},
            'pconvert': {hasAccess: false},
            'metadata-setup': {hasAccess: false},
            'pipeline-forensics': {hasAccess: false},
            'pipelineflows': {hasAccess: false},
            'attribution-setup': {hasAccess: false},
            'program-effectiveness': {hasAccess: false},
            'programeffectiveness': {hasAccess: false},
            'gtm-activity': {hasAccess: false},
            'meetings': {hasAccess: false},
            'rep-ramp': {hasAccess: false},
            'scenarios': {hasAccess: false},
            'win-rate': {hasAccess: false},
            'winflows': {hasAccess: false},
            'entity-match': {hasAccess: false},
            'win-loss-reasons': {hasAccess: false},
            'renewal-matching': {hasAccess: false},
            'hygiene': {hasAccess: false},
            'recipe-designer': {hasAccess: false},
            'recipe-results': {hasAccess: false},
            'goal-sets': {hasAccess: false},
            'quota-setup': {hasAccess: false},
            'manage-prompts': {hasAccess: false},
            'integrations': {hasAccess: false},
            'desktop-tools': {hasAccess: true},
            'scenario-settings': {hasAccess: false},
            'inbound-response-setup': {hasAccess: false},
            'configure-data': {hasAccess: false},
            'security': {hasAccess: true},
            'terms': {hasAccess: true},
        },
        "sales_ops_user": {
            "access-denied": {hasAccess: true},
            "admin": {hasAccess: true},
            "billing": {hasAccess: false},
            "company": {hasAccess: true},
            "faq": {hasAccess: true},
            "manage-users":  {hasAccess: false},
            "settings": {hasAccess: true},
            'board-stats': {hasAccess: false},
            'business-digest': {hasAccess: true},
            'config': {hasAccess: true},
            'account-management': {hasAccess: true},
            'customer-invoices': {hasAccess: true},
            'department-spend': {hasAccess: false},
            'arr-schedule': {hasAccess: true},
            'dealexplorer': {hasAccess: true},
            'forecast': {hasAccess: true},
            'forecast-setup': {hasAccess: true},
            'gtm-stats': {hasAccess: true},
            'gtm-stats-segments': {hasAccess: true},
            'inbound-follow-up': {hasAccess: true},
            'opp-creation': {hasAccess: true},
            'pclose': {hasAccess: true},
            'pconvert': {hasAccess: true},
            'pipeline-forensics': {hasAccess: true},
            'pipelineflows': {hasAccess: true},
            'attribution-setup': {hasAccess: true},
            'program-effectiveness': {hasAccess: true},
            'programeffectiveness': {hasAccess: true},
            'gtm-activity': {hasAccess: true},
            'meetings': {hasAccess: true},
            'rep-ramp': {hasAccess: true},
            'scenarios': {hasAccess: true},
            'win-rate': {hasAccess: true},
            'winflows': {hasAccess: true},
            'entity-match': {hasAccess: true},
            'win-loss-reasons': {hasAccess: true},
            'renewal-matching': {hasAccess: true},
            'hygiene': {hasAccess: true},
            'recipe-designer': {hasAccess: true},
            'recipe-results': {hasAccess: true},
            'goal-sets': {hasAccess: true},
            'quota-setup': {hasAccess: true},
            'metadata-setup': {hasAccess: true},
            'manage-prompts': {hasAccess: true},
            'integrations': {hasAccess: false},
            'desktop-tools': {hasAccess: true},
            'scenario-settings': {hasAccess: true},
            'inbound-response-setup': {hasAccess: true},
            'configure-data': {hasAccess: true},
            'security': {hasAccess: true},
            'terms': {hasAccess: true},
        },
        "marketing_user": {
            "access-denied": {hasAccess: true},
            "admin": {hasAccess: false},
            "billing": {hasAccess: false},
            "company": {hasAccess: false},
            "faq": {hasAccess: false},
            "manage-users":  {hasAccess: false},
            "settings": {hasAccess: true},
            'board-stats': {hasAccess: false},
            'business-digest': {hasAccess: true},
            'config': {hasAccess: true},
            'account-management': {hasAccess: true},
            'customer-invoices': {hasAccess: false},
            'department-spend': {hasAccess: false},
            'arr-schedule': {hasAccess: false},
            'dealexplorer': {hasAccess: true},
            'forecast': {hasAccess: true},
            'forecast-setup': {hasAccess: false},
            'gtm-stats': {hasAccess: true},
            'gtm-stats-segments': {hasAccess: false},
            'inbound-follow-up': {hasAccess: true},
            'opp-creation': {hasAccess: true},
            'pclose': {hasAccess: true},
            'pconvert': {hasAccess: true},
            'pipeline-forensics': {hasAccess: true},
            'pipelineflows': {hasAccess: true},
            'attribution-setup': {hasAccess: false},
            'program-effectiveness': {hasAccess: true},
            'programeffectiveness': {hasAccess: true},
            'gtm-activity': {hasAccess: true},
            'meetings': {hasAccess: true},
            'rep-ramp': {hasAccess: true},
            'scenarios': {hasAccess: false},
            'win-rate': {hasAccess: true},
            'winflows': {hasAccess: true},
            'entity-match': {hasAccess: true},
            'win-loss-reasons': {hasAccess: true},
            'renewal-matching': {hasAccess: false},
            'hygiene': {hasAccess: true},
            'recipe-designer': {hasAccess: true},
            'recipe-results': {hasAccess: true},
            'goal-sets': {hasAccess: true},
            'quota-setup': {hasAccess: false},
            'metadata-setup': {hasAccess: false},
            'manage-prompts': {hasAccess: false},
            'integrations': {hasAccess: false},
            'desktop-tools': {hasAccess: true},
            'scenario-settings': {hasAccess: false},
            'inbound-response-setup': {hasAccess: false},
            'configure-data': {hasAccess: false},
            'security': {hasAccess: true},
            'terms': {hasAccess: true},
        },
        "marketing_ops_user": {
            "access-denied": {hasAccess: true},
            "admin": {hasAccess: true},
            "billing": {hasAccess: false},
            "company": {hasAccess: true},
            "faq": {hasAccess: true},
            "manage-users":  {hasAccess: false},
            "settings": {hasAccess: true},
            'board-stats': {hasAccess: false},
            'business-digest': {hasAccess: true},
            'config': {hasAccess: true},
            'account-management': {hasAccess: true},
            'customer-invoices': {hasAccess: false},
            'department-spend': {hasAccess: false},
            'arr-schedule': {hasAccess: false},
            'dealexplorer': {hasAccess: true},
            'forecast': {hasAccess: true},
            'forecast-setup': {hasAccess: false},
            'gtm-stats': {hasAccess: true},
            'gtm-stats-segments': {hasAccess: true},
            'inbound-follow-up': {hasAccess: true},
            'opp-creation': {hasAccess: true},
            'pclose': {hasAccess: true},
            'pconvert': {hasAccess: true},
            'pipeline-forensics': {hasAccess: true},
            'pipelineflows': {hasAccess: true},
            'attribution-setup': {hasAccess: true},
            'program-effectiveness': {hasAccess: true},
            'programeffectiveness': {hasAccess: true},
            'gtm-activity': {hasAccess: true},
            'meetings': {hasAccess: true},
            'rep-ramp': {hasAccess: true},
            'scenarios': {hasAccess: true},
            'win-rate': {hasAccess: true},
            'winflows': {hasAccess: true},
            'entity-match': {hasAccess: true},
            'win-loss-reasons': {hasAccess: true},
            'renewal-matching': {hasAccess: true},
            'hygiene': {hasAccess: true},
            'recipe-designer': {hasAccess: true},
            'recipe-results': {hasAccess: true},
            'goal-sets': {hasAccess: true},
            'quota-setup': {hasAccess: false},
            'metadata-setup': {hasAccess: true},
            'manage-prompts': {hasAccess: true},
            'integrations': {hasAccess: false},
            'desktop-tools': {hasAccess: true},
            'scenario-settings': {hasAccess: false},
            'inbound-response-setup': {hasAccess: true},
            'configure-data': {hasAccess: true},
            'security': {hasAccess: true},
            'terms': {hasAccess: true},
        },
        "finance_user": {
            "access-denied": {hasAccess: true},
            "admin": {hasAccess: true},
            "billing": {hasAccess: true},
            "company": {hasAccess: false},
            "faq": {hasAccess: true},
            "manage-users":  {hasAccess: false},
            "settings": {hasAccess: true},
            'board-stats': {hasAccess: true},
            'business-digest': {hasAccess: true},
            'config': {hasAccess: true},
            'account-management': {hasAccess: true},
            'customer-invoices': {hasAccess: true},
            'department-spend': {hasAccess: true},
            'arr-schedule': {hasAccess: true},
            'dealexplorer': {hasAccess: true},
            'forecast': {hasAccess: true},
            'forecast-setup': {hasAccess: false},
            'gtm-stats': {hasAccess: true},
            'gtm-stats-segments': {hasAccess: false},
            'inbound-follow-up': {hasAccess: true},
            'opp-creation': {hasAccess: true},
            'pclose': {hasAccess: true},
            'pconvert': {hasAccess: true},
            'pipeline-forensics': {hasAccess: true},
            'pipelineflows': {hasAccess: true},
            'attribution-setup': {hasAccess: false},
            'program-effectiveness': {hasAccess: true},
            'programeffectiveness': {hasAccess: true},
            'gtm-activity': {hasAccess: true},
            'meetings': {hasAccess: true},
            'rep-ramp': {hasAccess: true},
            'scenarios': {hasAccess: true},
            'win-rate': {hasAccess: true},
            'winflows': {hasAccess: true},
            'entity-match': {hasAccess: true},
            'win-loss-reasons': {hasAccess: true},
            'renewal-matching': {hasAccess: true},
            'hygiene': {hasAccess: true},
            'recipe-designer': {hasAccess: true},
            'recipe-results': {hasAccess: true},
            'goal-sets': {hasAccess: true},
            'quota-setup': {hasAccess: false},
            'metadata-setup': {hasAccess: false},
            'manage-prompts': {hasAccess: false},
            'integrations': {hasAccess: false},
            'desktop-tools': {hasAccess: true},
            'scenario-settings': {hasAccess: false},
            'inbound-response-setup': {hasAccess: false},
            'configure-data': {hasAccess: false},
            'security': {hasAccess: true},
            'terms': {hasAccess: true},
        },
    };

export default RolePermissions;
